import { apiRequest, HttpMethod } from '@hqo/shared-modules/dist/api-request';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { useApi } from 'app/shared/contexts/api';

interface CancelVisitVars {
  visitId: string;
  buildingUuid: string;
}

/**
 * Cancel a visit inline (no redirect into the miniapp — Lis, MBX-950).
 * `DELETE /api/visitor-registration/v2/locations/{buildingUuid}/visits/{visitId}`.
 *
 * Refetching is the caller's job, as with check-in and the event cancel. This used to invalidate both
 * feed paths here, which raced the projection: the read went out before the cancellation had landed
 * and put the visit straight back on the list.
 */
export const useCancelVisitMutation = (): UseMutationResult<void, Error, CancelVisitVars> => {
  const { apiUrl, getAuthHeaders, getDefaultHeaders } = useApi();

  return useMutation<void, Error, CancelVisitVars>({
    mutationFn: async ({ visitId, buildingUuid }: CancelVisitVars) => {
      const headers = { ...(await getAuthHeaders()), ...getDefaultHeaders(buildingUuid) };
      await apiRequest<void, void, void>({
        url: `${apiUrl}/api/visitor-registration/v2/locations/${buildingUuid}/visits/${visitId}`,
        method: HttpMethod.DELETE,
        headers,
      });
    },
  });
};
